<template lang="pug">
  div
    .eachbox.text-left(v-for="(item,index) in data" )
      .title.border.border3-gre-d9.cursor-pointer.rounded-20.px-20.my-12.overflow-hidden.transition.duration-300.ease-in-out(@click="extend(index)" 
      class="hover:bg-grey-f2 "
      :class="{'max-h-auto':isExtend[index], 'max-h-48': !isExtend[index],'bg-grey-f2': isExtend[index],'border-grey-f2': isExtend[index], 'hover:border-grey-f2' :isExtend[index]}" )
        .flex.justify-between.items-center
          .flex.item-center
            .flex.items-start.ml-10.pt-3.px-2.pr-5(@click="goEach(item)" :class="{'cursor-pointer': $route.path != '/model' && $route.path != '/faq'}")
              .text-main-0.text-24.mr-14.pt-10( v-if="customIcon") {{customIcon}}
              .pt-10(:class="{'wordDot': !isExtend[index]}" :style="`font-size:${fontSize}px;`") {{item.name}} 
          div.rounded-50.origin-center.transition.duration-300.ease-in-out.cursor-pointer( class="hover:bg-grey-f2 " :class="{'transform':isExtend[index], '-rotate-180': isExtend[index]  }")
            iCon.h-24.w-24.inline-block(:iconClass="'dropdown'"  type="svg")
        slot(:name="'content'" :data="item" :index="index")
        //- .bg-gray-300.w-full.h-3.mt-14
        //- .text-left.py-40.px-16
        //-   div(v-html="item.answer") 
        //-   .bg-gray-300.w-200.h-3.mt-48.mb-24.m-auto
        //-   .text-14.text-center Was this article helpful?
        //-   .m-auto.flex.justify-center.mt-16
        //-     Button.w-140.mr-16( :text="$t('__globeButton.__yes')"  type="normal" :disable="false" )
        //-     Button.w-140( :text="$t('__globeButton.__no')"  type="cancel" :disable="false" )
          



</template>

<script>

import Button from '@/components/Button.vue';


export default {
  name: 'faqModel',
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
    optionArr:{
      type: Array,
      require: false,
    },
    showLength:{
      type: Boolean,
      require: false,
      default: false,
    },
    customIcon:{
      type: String,
      required: false,
    },
    height:{
      type: [String, Number],
      required: false,
      default:40,
    },
    fontSize:{
      type: [String, Number],
      required: false,
      default:14,
    }
  },
  components:{
    Button,
  },
  data() {
    return {
      // hasPin: false,
      mainSelect:'',
      obj:[
        {id: 'ax',
          name: 'aaaaa',
        },
        {id: 'bx',
          name: 'bbbbb',
        },
        {id: 'cx', 
          name: 'ccccc',
        },
        {id: 'dx', 
          name: 'ddddd',
        }
      ],
      isExtend:[],
    };
  },
  created(){
    
    // const containsKey = (obj, key ) => Object.keys(obj).includes(key);
    // this.hasPin = containsKey(this.data[0], 'pin');
  },
  mounted(){
    this.data.forEach(() => {
      this.isExtend.push(false)
    });
    
  },
  methods:{
    pin(i){
      this.$emit("onClick", i);
    },
    extend(e){
      this.$set(this.isExtend, e, !this.isExtend[e])
    },
    goEach(e){
      if(this.$route.path.indexOf('model') < 1 && this.$route.path.indexOf('faq') < 1 ){
        this.$router.push({
          path: `/info/model/${e.name}`,
          query: {
            // type: `${this.selected}`,
            // keyword: `${e.name}`,
            // os: `${this.osSelect}`,
          },
        }).catch(err => err);
      }
    }
  },
  watch:{

  },
  computed: {
    hasPin() {
      const containsKey = (obj, key ) => Object.keys(obj).includes(key);
      return containsKey(this.data[0], 'pin');
    }
  },
}
</script>

<style lang="scss" scoped>


.maxHeight{
  max-height: 9999px;
}


// .eachbox{
//   .title{
//     max-height: 48px;
//     // transition: max-height 0.1s ease-in-out;
//     &.noshow{
//       max-height: 48px;
//     }
//     &.show{
//       max-height: 9999px;
//     }
//   }
    
// }

</style>
